import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '热门漫画', href: '/category/all' },
      { label: '最新更新', href: '/category/all' },
      { label: '排行榜', href: '/category/romance' },
      { label: '关于我们', href: '/about' },
    ],
  },
  {
    title: '漫画分类',
    links: [
      { label: '恋爱漫画', href: '/category/romance' },
      { label: '奇幻冒险', href: '/category/fantasy' },
      { label: '热血动作', href: '/category/action' },
      { label: '都市剧情', href: '/category/drama' },
    ],
  },
  {
    title: '关注我们',
    links: [
      { label: '新浪微博', href: '#', icon: 'ri-weibo-line' },
      { label: '微信公众号', href: '#', icon: 'ri-wechat-line' },
      { label: 'QQ群', href: '#', icon: 'ri-qq-line' },
      { label: '联系邮箱', href: 'mailto:contact@waiwaimanhua.com', icon: 'ri-mail-line' },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubscribeStatus('loading');
    try {
      const formData = new FormData(e.currentTarget);
      const honeypotVal = (formData.get('contact_alt') as string || '').trim();
      if (honeypotVal) {
        setSubscribeStatus('success');
        setSubscribeMsg('订阅成功！感谢您的关注！');
        setEmail('');
        return;
      }
      formData.delete('contact_alt');

      const response = await fetch('https://readdy.ai/api/form/d96fdl7pg5pqhofcuobg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '';
      if (response.ok && parsed?.code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMsg('订阅成功！感谢您的关注！');
        setEmail('');
      } else if (serverMsg.includes('spam')) {
        setSubscribeStatus('error');
        setSubscribeMsg('提交出现异常，请稍后重试');
      } else {
        setSubscribeStatus('error');
        setSubscribeMsg(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMsg('网络异常，请稍后重试');
    }
  };

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-2xl font-bold text-background-50">歪歪漫画</span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              歪歪漫画网汇集最新高清免费韩国漫画大全，主打热门无删减韩漫在线阅读，为您呈现原汁原味的韩国漫画作品库。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              订阅更新
            </h4>
            <form data-readdy-form="" id="footer-newsletter" onSubmit={handleSubscribe} className="relative">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入邮箱订阅更新"
                required
                className="w-full bg-transparent border-b border-background-50/30 pb-2 text-sm text-background-50 placeholder:text-background-50/40 outline-none focus:border-background-50/70 transition-colors"
              />
              <input
                type="text"
                name="contact_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-honeypot"
              />
              <button
                type="submit"
                disabled={subscribeStatus === 'loading'}
                className="absolute right-0 top-0 w-8 h-8 flex items-center justify-center text-background-50/60 hover:text-background-50 transition-colors cursor-pointer disabled:opacity-50"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
              {subscribeStatus !== 'idle' && (
                <p className={`text-xs mt-2 ${subscribeStatus === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
                  {subscribeMsg}
                </p>
              )}
            </form>
            <p className="text-xs text-background-50/40 mt-2">
              订阅即表示同意我们的
              <a href="#" className="underline cursor-pointer">隐私政策</a>
            </p>
          </div>

          {footerLinks.slice(0, 2).map((section) => (
            <div key={section.title}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              {footerLinks[2].title}
            </h4>
            <ul className="space-y-2.5">
              {footerLinks[2].links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="flex items-center gap-2 text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    {...(link.href.startsWith('mailto:') ? {} : { target: '_blank', rel: 'nofollow noopener' })}
                  >
                    {link.icon && <i className={`${link.icon} text-base`}></i>}
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 歪歪漫画网 - 版权所有 | 本站所有漫画均来自互联网，仅供学习交流使用
            </p>
            <div className="flex items-center gap-4 text-xs text-background-50/40">
              <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>

      <div className="overflow-hidden select-none pointer-events-none">
        <div className="font-heading text-[12vw] font-black text-background-50/5 leading-none whitespace-nowrap tracking-tighter">
          歪歪漫画 WAIWAI COMICS
        </div>
      </div>
    </footer>
  );
}